import { createAction } from '@'
import { $tableLoading } from '../stores'

export default createAction('table:SetTableLoading', (name, loading) => {
    $tableLoading.subStore(name).setState(() => loading)
})
